import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import StickyBanner from '../layouts/StickyBanner/StickyBanner';
import HeroProductsForm from '../layouts/HeroProductsForm/HeroProductsForm';
import BenefitsSection from '../layouts/BenefitsSection/BenefitsSection';
import HighlightSection from '../layouts/HighlightSection/HighlightSection';
import { ContentBannerSection } from '../layouts/ContentBannerSection/ContentBannerSection';
import { CaseTabsSection } from '../layouts/CaseTabsSection/CaseTabsSection';
import TestimonialsSection from '../layouts/TestimonialsSection/TestimonialsSection';
import { ImageCardsSection } from '../layouts/ImageCardsSection/ImageCardsSection';
import { ImageBand } from '../layouts/ImageBand/ImageBand';
// import RedirecionModal from '.././layouts/modal/RedirectionModal';
import { BrandUtil, LoadingIcon, wineryDirectStates, GetParam } from 'dw-us-ui';
import axios from 'axios';
import {
	getPageHeroBannerFields,
	getImageCardSectionFields,
	getImageBandItems,
} from '../utils/landingPageData';
const contentful = require('contentful');

// Styled Loading State Container
const LoadingContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
	font-size: 18px;
`;

const HomePage = () => {
	const [isLoading, setLoading] = useState(true);
	const [contentfulData, setContentfulData] = useState(null);
	const [products, setProducts] = useState([]);
	const [cartItems, setCartItems] = useState([]);
	const brand = BrandUtil.getBrand();
	const brandTag = BrandUtil.content(brand).tag.toLowerCase();
	const [activeProduct, setActiveProduct] = useState(null);
	const [activeProductIndex, setActiveProductIndex] = useState(0);
	const [caseData, setCaseData] = useState(null); // State for active product's case data
	const [promo] = useState(GetParam('promoCode'));
	const [isPresell, setIsPresell] = useState(false); // Add this state variable
	const [wineClubOffer, setWineClubOffer] = useState(null);

	const brandSpaceIDMap = {
		wsj: 'm1b7s66kk1b9', // us-wsj
		npr: '6rxbwdlytrj8', // us-npr
		law: 'pcz1l1qufd2i', // us-law
		osw: '2z1yjaidgv67', // us-osw
		tcm: 'pcz1l1qufd2i', // us-tcm
		fox: '1nwewppcllht', // us-fox aka us-wlb
		bon: '9q3prfdsy8fi', // us-bon aka us-bat
	};
	const brandAccessToken = {
		wsj: {
			developmentToken: 'YJsEIjwwgMRwIqtQGOi0DjVMm5WjzmXjTbs2X4Vjf-Q',
			productionToken: 'GRCsvI733yQ0vO1524fUInLCTGbB3-k_oGG0U8NF27g',
		}, // us-wsj
		npr: {
			developmentToken: 'rZmgIN1XXvaK8gNyfPzDCeDc8_h2mY4ZTnH3Euqsh9Y',
			productionToken: 'PMnkPCQ8QG4FEDj7ermSE5YmPzuc1HTfdWlxwhv1hcY',
		}, // us-npr
		law: {
			developmentToken: 'k6aCVfg9F-Sm6S2Gv2lpUwxkGg_yArH1oNVtdIgtkNA',
			productionToken: 'a_PJJkskgCDQlffRHqnqEBSMyomH04SdXDwfEbcN6sE',
		}, // us-law
		osw: {
			developmentToken: 'blarUaSCQiRcnrpaDr8PaMj1UBkq4q1Xaw76XNx7KK8',
			productionToken: 'q6cj3VQBgpvNhlvsXQfkVP2-Hwz5IyXjMR-zBmwBndA',
		}, // us-owa
		tcm: {
			developmentToken: 'k6aCVfg9F-Sm6S2Gv2lpUwxkGg_yArH1oNVtdIgtkNA',
			productionToken: 'GRCsvI733yQ0vO1524fUInLCTGbB3-k_oGG0U8NF27g',
		}, // us-tcm
		fox: {
			developmentToken: 'bamw0Mu4IkJVv0Qdut2b9cHWtr8QZatXvTxEqI61cX8',
			productionToken: 'bamw0Mu4IkJVv0Qdut2b9cHWtr8QZatXvTxEqI61cX8',
		}, // us-fox
		bon: {
			developmentToken: '8O3iy21eZd-zU32Pe2anXBPBY76p_HNVfCH2Fck9l80',
			productionToken: 'I2bqpKej5IqPE-dCB5zFj3wyC97isXdz1fd-k13cuOU',
		}, // us-bon
	};
	const selectedSpaceID = brandSpaceIDMap[brandTag] || 'pcz1l1qufd2i'; // Provide a fallback

	const getEnvironment = () => {
		const url = window.location.href;
		if (url.includes('.uat')) return 'uat';
		if (url.includes('.st')) return 'st';
		if (url.includes('www') || url.includes('preview')) return 'master';
		return 'master';
	};

	const getAccessToken = () => {
		const url = window.location.href;

		switch (true) {
			case url.includes('.uat'):
				return brandAccessToken[brandTag]['developmentToken'];
			case url.includes('.st'):
				return brandAccessToken[brandTag]['developmentToken'];
			case url.includes('www') || url.includes('preview'):
				return brandAccessToken[brandTag]['productionToken'];
			default:
				return brandAccessToken[brandTag]['productionToken'];
		}
	};
	// Contentful API Configuration
	const client = contentful.createClient({
		space: selectedSpaceID,
		accessToken: getAccessToken(),
		host: 'cdn.contentful.com',
		environment: getEnvironment(),
	});

	const queryParams = new URLSearchParams(window.location.search);
	const offerParam = queryParams.get('offer');

	const additionalFilters = {
		'fields.slug': offerParam,
	};

	const contentfulQuery = {
		content_type: 'landingPage',
		// Resolve linked entries: `reference` (pageHeroBanner) and
		// `imageCardSection` are 1 level deep; `imageBand` -> `image` -> asset
		// needs an extra level, so request include depth 2.
		include: 2,
		...additionalFilters,
	};
	const [offerCode, setOfferCode] = useState(null);

	// Fetch Contentful Data
	useEffect(() => {
		setLoading(true);
		client
			.getEntries(contentfulQuery)
			.then((response) => {
				setContentfulData(response.items[0]?.fields || {});
				let VoucherDetails = {};

				if (
					response.items &&
					response.items.length > 0 &&
					response.items[0]?.fields
				) {
					const landingPageFields = response.items[0]?.fields;
					let {
						heroVoucherIcon,
						paymentStepSubHeadlines,
						checkoutCaseName,
						wineClubLanguage,
						redirectPromo,
						voucherCopy,
						thirdPartyCopy,
						enableOrderSummary,
						newCustomerOffers,
						partnerLegalNotice,
					} = landingPageFields;

					// heroVoucherText / voucher colours moved to the linked
					// pageHeroBanner entry (landingPage.reference). Optional.
					const {
						heroVoucherText,
						heroVoucherBackgroundColor,
						heroVoucherTextColor,
						voucherBackgroundColor,
						voucherTextColor,
					} = getPageHeroBannerFields(landingPageFields);

					const isFoxOrBon = brandTag === 'fox' || brandTag === 'bon';
					const bgColor = isFoxOrBon
						? heroVoucherBackgroundColor?.value
						: voucherBackgroundColor?.value;
					const textColor = isFoxOrBon
						? heroVoucherTextColor?.value
						: voucherTextColor?.value;

					VoucherDetails = {
						heroVoucherText,
						paymentStepSubHeadlines,
						checkoutCaseName,
						voucherBackgroundColor: bgColor,
						voucherTextColor: textColor,
						heroVoucherIcon: heroVoucherIcon?.fields?.file?.url,
						wineClubLanguage,
						redirectPromo,
						voucherCopy,
						thirdPartyCopy,
						enableOrderSummary,
						newCustomerOffers,
						partnerLegalNotice,
					};
				}
				window.dispatchEvent(
					new CustomEvent('setContentfulDataCheckout', {
						detail: VoucherDetails,
					})
				);

				localStorage.setItem(
					'setContentfulDataCheckout',
					JSON.stringify(VoucherDetails)
				);
			})
			.catch((error) => {
				console.error('Error fetching Contentful data:', error);
			})
			.finally(() => {
				setLoading(false);
			});
	}, []);
	useEffect(() => {
		const fetchOperatorMsg = async () => {
			try {
				// 1. Fetch the offer response
				const response = await axios.get(`/api/offer/${promo}`);

				const offerResponse = response.data?.response;

				// API returns "wineclubOffer" (lowercase c)
				const wineClubValue = offerResponse?.wineclubOffer;

				if (typeof wineClubValue === 'boolean') {
					setWineClubOffer(wineClubValue);
				} else {
					setWineClubOffer(null);
				}

				const operatorMsg = offerResponse?.operatorMsg;
				const mainItems = offerResponse?.mainItems || [];

				// Check if any product has a presell SKU
				const hasPresellItem = mainItems.some((item) =>
					item.product?.skus?.some((sku) => sku.preSellItem === true)
				);

				setIsPresell(hasPresellItem);

				// 2. Only run your WD- logic if operatorMsg exists
				if (operatorMsg && operatorMsg.includes('WD-')) {
					const rawCode = operatorMsg.split('WD-')[1];
					const code = rawCode.trim().substring(0, 7);
					setOfferCode(code);
				}
			} catch (error) {
				console.error('Error fetching operator message:', error);
				setIsPresell(false);
				setWineClubOffer(null);
			}
		};

		if (promo) {
			// Avoid unnecessary API calls when no promo code is available
			fetchOperatorMsg();
		}
	}, [promo]);

	// Fetch Product Data for Product Codes
	const fetchProductData = async (itemCode) => {
		try {
			const response = await fetch(`/api/product/item/${itemCode}`);
			if (!response.ok) throw new Error(`Error fetching product ${itemCode}`);
			const productData = await response.json();
			return productData;
		} catch (error) {
			console.error('Product fetch error:', error);
			return null;
		}
	};

	useEffect(() => {
		if (contentfulData?.productCodes?.length) {
			const uniqueProductCodes = [...new Set(contentfulData.productCodes)];

			let optionFetched = [];
			const fetchProducts = async () => {
				const fetchedProducts = await Promise.all(
					uniqueProductCodes?.map(async (code, index) => {
						const productData = await fetchProductData(code);
						optionFetched[index] = {
							itemCode: code,
							index,
							product: productData?.response,
						};
						return {
							...productData?.response,
							customTitle:
								contentfulData?.customProductTitles?.[index] ||
								productData?.response?.name,
						};
					})
				);
				setProducts(fetchedProducts?.filter(Boolean));

				if (optionFetched?.length > 0) {
					const filteredOptionFetched = optionFetched.filter(
						(entry) => entry.product !== undefined
					);

					localStorage.setItem(
						'options',
						JSON.stringify(filteredOptionFetched)
					);
					window.dispatchEvent(
						new CustomEvent('optionsFetched', { detail: filteredOptionFetched })
					);
				}
				setActiveProduct(fetchedProducts?.[0] || null);
			};

			fetchProducts();
		}
	}, [contentfulData]);

	// Update Cart Items
	const updateCartItem = async (itemCode, quantity = 1) => {
		try {
			const response = await fetch(
				`/api/cart/itemcode/${itemCode}/${quantity}`,
				{ method: 'PUT' }
			);

			if (!response.ok) throw new Error('Failed to update cart');
			const updatedCart = await response.json();

			setCartItems(updatedCart.items);
		} catch (error) {
			console.error('Error updating cart:', error);
		}
	};
	// Fetch Case Data for Active Product
	useEffect(() => {
		const fetchCaseData = async () => {
			if (!activeProduct?.itemCode) return;

			try {
				const response = await fetch(
					`/api/product/case/${activeProduct.itemCode}`
				);
				if (!response.ok) throw new Error('Failed to fetch case data');
				const caseDataResponse = await response.json();

				setCaseData(caseDataResponse.response);
			} catch (error) {
				console.error('Error fetching case data:', error);
			}
		};

		fetchCaseData();
	}, [activeProduct]);

	useEffect(() => {
		function handleOptionSelected(event) {
			const { index, itemCode } = event.detail;
			// look up by itemCode first, fallback to index
			const chosen =
				products.find((p) => p.itemCode === itemCode) || products[index];

			if (chosen) {
				setActiveProductIndex(index);
				setActiveProduct(chosen);
			}
		}

		window.addEventListener('checkoutOptionSelected', handleOptionSelected);
		return () => {
			window.removeEventListener(
				'checkoutOptionSelected',
				handleOptionSelected
			);
		};
	}, [products]);

	if (isLoading || !contentfulData) {
		return (
			<LoadingContainer>
				<LoadingIcon />
			</LoadingContainer>
		);
	}
	// Nested entries are optional: read them defensively for section gating.
	const heroBannerFields = getPageHeroBannerFields(contentfulData);
	const imageCardSectionFields = getImageCardSectionFields(contentfulData);
	const imageBandItems = getImageBandItems(contentfulData);

	const sectionMap = {
		'section-lp-hero': (heroBannerFields?.pageHeroText ||
			contentfulData?.productCodes?.length > 0) && (
			<HeroProductsForm
				contentfulData={contentfulData}
				activeProduct={activeProduct}
				setActiveProduct={setActiveProduct}
				activeProductIndex={activeProductIndex}
				setActiveProductIndex={setActiveProductIndex}
				products={products}
				brandTag={brandTag}
				wineClubOffer={wineClubOffer}
			/>
		),
		'section-lp-benefits': contentfulData?.benefitsColumnsHeadline && (
			<BenefitsSection contentfulData={contentfulData} />
		),
		'section-lp-perks': contentfulData?.highlightItemHeadlines?.length > 0 && (
			<HighlightSection contentfulData={contentfulData} />
		),
		'section-lp-content-banner': contentfulData?.contentBannerHeadline && (
			<ContentBannerSection contentfulData={contentfulData} />
		),
		'section-lp-image-band': imageBandItems.length > 0 && (
			<ImageBand contentfulData={contentfulData} />
		),
		'section-lp-image-cards':
			imageCardSectionFields?.imageCardsSectionHeadline && (
				<ImageCardsSection
					contentfulData={contentfulData}
					brandTag={brandTag}
				/>
			),
		'section-lp-case-tabs': Array.isArray(contentfulData?.productCodes) &&
			contentfulData?.productCodes.length > 0 && (
				<CaseTabsSection
					contentfulData={contentfulData}
					products={products}
					activeProduct={activeProduct}
					setActiveProduct={setActiveProduct}
					updateCartItem={updateCartItem}
					setActiveProductIndex={setActiveProductIndex}
					activeProductIndex={activeProductIndex}
					caseData={caseData}
					brandTag={brandTag}
					isPresell={isPresell}
				/>
			),
		'section-lp-testimonials': contentfulData?.customerReviewsHeadline && (
			<TestimonialsSection
				contentfulData={contentfulData}
				brandTag={brandTag}
			/>
		),
	};

	const defaultSectionOrder = [
		'section-lp-hero',
		'section-lp-image-band',
		'section-lp-benefits',
		'section-lp-perks',
		'section-lp-content-banner',
		'section-lp-image-cards',
		'section-lp-case-tabs',
		'section-lp-testimonials',
	];

	const rawSections = Array.isArray(contentfulData?.sectionPositions)
		? contentfulData.sectionPositions
		: contentfulData?.sectionPositions?.split(',') || [];

	const priorityOrder = rawSections
		.map((str) => str.trim().replace(/^\.+/, ''))
		.filter(Boolean);

	const finalRenderOrder = [
		...priorityOrder,
		...defaultSectionOrder.filter((item) => !priorityOrder.includes(item)),
	];

	// The first section that actually renders (its sectionMap value is truthy).
	// Used to tell the hero whether it is the very first component on the page.
	const firstRenderedSectionKey = finalRenderOrder.find(
		(sectionKey) => sectionMap[sectionKey]
	);

	return (
		<>
			<StickyBanner
				products={products}
				customProductTitles={contentfulData?.customProductTitles}
				activeProduct={activeProduct}
				setActiveProduct={setActiveProduct}
				activeProductIndex={activeProductIndex} // Pass the active index
				setActiveProductIndex={setActiveProductIndex} // Pass the setter for index
				updateCartItem={updateCartItem}
				brandTag={brandTag}
				isPresell={isPresell}
				voucherCopy={contentfulData?.voucherCopy}
			/>
			{finalRenderOrder.map((sectionKey) => {
				let section = sectionMap[sectionKey] || null;
				// Sections that render the sticky-banner height spacer need to know
				// when they are the very first rendered section on the page.
				const spacerAwareSections = [
					'section-lp-hero',
					'section-lp-image-band',
				];
				if (section && spacerAwareSections.includes(sectionKey)) {
					section = React.cloneElement(section, {
						isFirstSection: firstRenderedSectionKey === sectionKey,
					});
				}
				return <React.Fragment key={sectionKey}>{section}</React.Fragment>;
			})}
		</>
	);
};

export default HomePage;
